<div class="sheet-content" [ngClass]="this.store.sheetHeight()" #sheetContent>
  <div class="top-buttons-row">
    <div class="left-action">
      <button
        mat-button
        class="error-button enable-with-keyboard"
        (click)="this.$hangForm()?.handleCancel()"
      >
        Cancel
      </button>
    </div>

    <div class="center-action">
      <button
        mat-raised-button
        class="toggle-view-button enable-with-keyboard"
        (click)="toggleHeight()"
      >
        <div class="toggle-view-button-content">
          <mat-icon>
            @if (store.sheetHeight() === HangSheetHeight.COLLAPSED) {
              keyboard_double_arrow_up
            } @else {
              keyboard_double_arrow_down
            }
          </mat-icon>
        </div>
      </button>
    </div>

    <div class="right-action">
      <button
        mat-flat-button
        (click)="this.$hangForm()?.handleSubmit()"
        [disabled]="!$hangForm()?.$submittable()"
        class="enable-with-keyboard"
      >
        @if (this.store.mode() === "edit") {
          Save
        } @else {
          Create
        }
      </button>
    </div>
  </div>

  @defer (when $visible()) {
    @if ($visible()) {
      <hang-form
        #hangForm
        [parentOverlayType]="HangFormOverlayType.SHEET"
        (created)="handleCreated($event)"
        (updated)="handleUpdated($event)"
        (cancel)="handleCancel()"
        (viewChange)="$formView.set($event)"
        (pendingHang)="$formPendingHang.set($event)"
        [hang]="store.formInputHang() ?? undefined"
        [timespan]="store.formInputTimespan() ?? undefined"
        [pueblo]="store.formInputPueblo() ?? undefined"
        [showFormTitle]="false"
        (changesMade)="store.setChangesMade($event)"
        [showPrimaryActions]="false"
      ></hang-form>
    }
  }
</div>
